"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoOverQuota = void 0;
var video_states_1 = require("@wix/wix-vod-constants/dist/common/video-states");
exports.isVideoOverQuota = function (videoItem) {
    return videoItem && videoItem.state === video_states_1.VIDEO_STATES.OVER_QUOTA;
}; //TODO remove if
//# sourceMappingURL=quota.js.map